import React, { useState, useMemo, useRef } from 'react'
import PrimaryButton from '../../components/atoms/PrimaryButton/index'
import { Button } from '@material-ui/core'
import Popup from '../../components/organisms/Popup/index'
import Swal from 'sweetalert2'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import StripeNewCardForm from '../../components/molecules/CheckoutPayment/StripeNewCardForm'
import axiosInstance from '../../Utils/Utility/axiosconfig'
import axios from 'axios'
import './Addnewcard.css'

const Addnewcard = (props) => {
    const [modalOpen, setmodalOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const stripeFormRef = useRef(null)
    const stripePromise = useMemo(() => loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY), [])

    const modalClose = () => {
        setmodalOpen(false)
    }

    const addcardapi = async () => {
        if (!stripeFormRef.current) return
        setLoading(true)
        try {
            const user = JSON.parse(localStorage.getItem('userData'))

            if (!user?.card_paymentid) {
                var body_data = {
                    account_id: process.env.REACT_APP_AUCTIONPAYKEY,
                    name: user?.first_name + ' ' + user?.last_name,
                    email: user?.email,
                    description: 'New Coins Customer',
                    api_endpoint: '/api/customer/create',
                    api_method: 'post',
                }
                const { data } = await axiosInstance.post('/api/auctionio_payment_api', body_data)

                if (data.status == 'success') {
                    user.card_paymentid = data.data.responseData.id
                    localStorage.setItem('userData', JSON.stringify(user))
                    const { data_res } = await axiosInstance.post('auctionpay/save_customer_id', {
                        customer_id: user.card_paymentid,
                    })
                } else {
                    Swal.fire({
                        title: data?.message || 'Something went wrong',
                        icon: 'error',
                        timer: 2500,
                        showConfirmButton: false,
                        position: 'center',
                    })
                }
            }

            const { error, paymentMethod } = await stripeFormRef.current.createPaymentMethod()
            if (error) {
                Swal.fire({
                    title: error.message,
                    icon: 'error',
                    timer: 2500,
                    showConfirmButton: false,
                    position: 'center',
                })
                setLoading(false)
                return
            }

            const res = await axiosInstance.post('mobileapi/stripe_pm_attach', {
                payment_method_id: paymentMethod.id,
                primary_card: false,
                user_id: user?.id,
            })

            if (res?.data?.status === 'success') {
                Swal.fire({
                    title: 'Card Saved Successfully',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                stripeFormRef.current.clearElements()
                props.upd()
                setmodalOpen(false)
            } else {
                Swal.fire({
                    title: res?.data?.message || 'Something went wrong',
                    icon: 'error',
                    timer: 2500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        } catch (err) {
            console.log(err)
        }
        setLoading(false)
    }

    return (
        <div className="addNewcard-parent">
            <Button onClick={() => setmodalOpen(true)}>
                <div className="Addcard-Payment">
                    <img src="/images/cards.png" alt="bank" />
                    <h6>ADD A NEW CARD</h6>
                    <img src="/images/ccard.png" alt="bank" />
                </div>
            </Button>
            <Popup modaltitle="Add Card" open={modalOpen} handleClose={() => modalClose()}>
                <div className="AddCard-Popup-Banner">
                    <div className="Addcard-Popup-Input">
                        <Elements stripe={stripePromise}>
                            <StripeNewCardForm ref={stripeFormRef} />
                        </Elements>
                    </div>
                    <PrimaryButton disabled={loading} label="Add" onClick={addcardapi} />
                </div>
            </Popup>
        </div>
    )
}

export default Addnewcard
